import { Dropdown, type DropdownItem, PillTab, PillTabs, Search } from '@atlas/ui-kit'
import { ListScope, type WorkOrderListState } from './list-state'

type FilterKey = 'brand' | 'assignee' | 'status'

const FILTERS: ReadonlyArray<{ key: FilterKey; label: string }> = [
	{ key: 'brand', label: 'Brand' },
	{ key: 'assignee', label: 'Assignee' },
	{ key: 'status', label: 'Status' },
]

export interface WorkOrderListToolbarProps {
	scope: ListScope
	onScope: (scope: ListScope) => void
	/** The search box's live text; the caller debounces it before it filters. */
	search: string
	onSearch: (text: string) => void
	state: Pick<WorkOrderListState, FilterKey>
	options: Record<FilterKey, DropdownItem[]>
	onFilter: (patch: Partial<Pick<WorkOrderListState, FilterKey>>) => void
}

/** The My tasks / All tasks switch, search, and the Brand, Assignee and Status multi-value filters above the work-order table. */
export function WorkOrderListToolbar({
	scope,
	onScope,
	search,
	onSearch,
	state,
	options,
	onFilter,
}: WorkOrderListToolbarProps) {
	return (
		<div className="mb-4 flex flex-wrap items-center gap-2">
			<PillTabs
				aria-label="Show orders"
				className="gap-0 rounded-atlas-full bg-atlas-light"
				selectedKeys={[scope]}
				onSelectionChange={(keys) => {
					const [next] = keys
					if (next) onScope(next as ListScope)
				}}
			>
				<PillTab id={ListScope.MINE}>My tasks</PillTab>
				<PillTab id={ListScope.ALL}>All tasks</PillTab>
			</PillTabs>
			<Search
				type="table"
				aria-label="Search work orders"
				placeholder="Search by name, number or id"
				value={search}
				onChange={onSearch}
				className="min-w-64 flex-1"
			/>
			{FILTERS.map(({ key, label }) => (
				<Dropdown
					key={key}
					aria-label={label}
					label={`${label}:`}
					placeholder="All"
					selectionMode="multiple"
					searchable
					iconLeft={false}
					className="max-w-64"
					items={options[key]}
					value={state[key]}
					onChange={(keys) => onFilter({ [key]: keys.map(String) })}
				/>
			))}
		</div>
	)
}
